<template>
  <div id="app" data-server-rendered="true">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
    // 解决莫名其妙会出现滚动条闪动问题 登录页
    setTimeout(() => {
      document.getElementById('app').style.height = '100%'
    }, 300)
  },
  methods: {
  }
}
</script>

<style>
  #app{
    color: #303133;
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    box-sizing: border-box;
  }
</style>
